var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pta-admin" }, [
    _c(
      "div",
      { staticClass: "page-titles border-bottom" },
      [
        _c("h3", [
          _vm._v("General Partners\n      "),
          _vm.users
            ? _c("span", { staticClass: "card-subtitle" }, [
                _vm._v(
                  _vm._s(
                    _vm.trans("general.total_result_found", {
                      count: _vm.users.total,
                    })
                  )
                ),
              ])
            : _c("span", { staticClass: "card-subtitle" }, [
                _vm._v(_vm._s(_vm.trans("general.no_result_found"))),
              ]),
        ]),
        _vm._v(" "),
        _c("sort-by", {
          staticClass: "pull-right",
          attrs: {
            "order-by-options": _vm.orderByOptions,
            "sort-by": _vm.filterUserForm.sort_by,
            order: _vm.filterUserForm.order,
          },
          on: {
            updateSortBy: (value) => {
              _vm.filterUserForm.sort_by = value
            },
            updateOrder: (value) => {
              _vm.filterUserForm.order = value
            },
          },
        }),
        _vm._v(" "),
        !_vm.showFilterPanel
          ? _c(
              "button",
              {
                staticClass: "btn btn-info btn-sm pull-right m-r-10",
                on: {
                  click: function ($event) {
                    _vm.showFilterPanel = !_vm.showFilterPanel
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-filter" }),
                _vm._v(" "),
                _c("span", { staticClass: "d-none d-sm-inline" }, [
                  _vm._v(_vm._s(_vm.trans("general.filter"))),
                ]),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid p-20 pta-filter",
        staticStyle: { "font-size": "0.625em" },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.showFilterPanel
                  ? _c("div", { staticClass: "card border-bottom" }, [
                      _c("div", { staticClass: "card-body p-4" }, [
                        _c("h4", { staticClass: "card-title" }, [
                          _vm._v(_vm._s(_vm.trans("general.filter"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-6 col-sm-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "name" } }, [
                                _vm._v(_vm._s(_vm.trans("user.name"))),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterUserForm.name,
                                    expression: "filterUserForm.name",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { id: "name", name: "name" },
                                domProps: { value: _vm.filterUserForm.name },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.filterUserForm,
                                      "name",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "email" } }, [
                                _vm._v(_vm._s(_vm.trans("user.email"))),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterUserForm.email,
                                    expression: "filterUserForm.email",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { id: "email", name: "email" },
                                domProps: { value: _vm.filterUserForm.email },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.filterUserForm,
                                      "email",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-1" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "account_manager_id" } },
                                [_vm._v("Rep.")]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.filterUserForm.account_manager_id,
                                      expression:
                                        "filterUserForm.account_manager_id",
                                    },
                                  ],
                                  staticClass: "custom-select col-12",
                                  attrs: { id: "account_manager_id" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.filterUserForm,
                                        "account_manager_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("All"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v("Lawin"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "2" } }, [
                                    _vm._v("Namo"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "3" } }, [
                                    _vm._v("Sajith"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "4" } }, [
                                    _vm._v("Tad"),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-1" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "is_premium" } }, [
                                _vm._v("Premium"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.filterUserForm.is_premium,
                                      expression: "filterUserForm.is_premium",
                                    },
                                  ],
                                  staticClass: "custom-select col-12",
                                  attrs: { id: "is_premium" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.filterUserForm,
                                        "is_premium",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("All"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v("No"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v("Yes"),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-1" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "sales_status_id" } },
                                [_vm._v("Outstanding")]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.filterUserForm.sales_status_id,
                                      expression:
                                        "filterUserForm.sales_status_id",
                                    },
                                  ],
                                  staticClass: "custom-select col-12",
                                  attrs: { id: "sales_status_id" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.filterUserForm,
                                        "sales_status_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("All"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "99" } }, [
                                    _vm._v("Any"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "3" } }, [
                                    _vm._v("Questionnaire"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "4" } }, [
                                    _vm._v("Marketing Materials"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v("Intro Call"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "2" } }, [
                                    _vm._v("Final Call"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "5" } }, [
                                    _vm._v("LP list approval"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "6" } }, [
                                    _vm._v("Campaign start"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "7" } }, [
                                    _vm._v("Weekly LP list approval"),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-1" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "status_id" } }, [
                                _vm._v("GP Status"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.filterUserForm.status_id,
                                      expression: "filterUserForm.status_id",
                                    },
                                  ],
                                  staticClass: "custom-select col-12",
                                  attrs: { id: "status_id" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.filterUserForm,
                                        "status_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("All"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      staticStyle: { color: "#ffbc34" },
                                      attrs: { value: "1" },
                                    },
                                    [_vm._v("Open")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      staticStyle: { color: "#029165" },
                                      attrs: { value: "2" },
                                    },
                                    [_vm._v("Won")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      staticStyle: { color: "#950000" },
                                      attrs: { value: "3" },
                                    },
                                    [_vm._v("Lost")]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-1" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "status" } }, [
                                _vm._v(_vm._s(_vm.trans("user.status"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.filterUserForm.status,
                                      expression: "filterUserForm.status",
                                    },
                                  ],
                                  staticClass: "custom-select col-12",
                                  attrs: { id: "status" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.filterUserForm,
                                        "status",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("All"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "activated" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans("user.status_activated")
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "pending_activation" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans(
                                            "user.status_pending_activation"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "pending_approval" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans(
                                            "user.status_pending_approval"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "banned" } }, [
                                    _vm._v(
                                      _vm._s(_vm.trans("user.status_banned"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "disapproved" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans("user.status_disapproved")
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.showFilterPanel
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-danger btn-sm pull-right",
                                on: {
                                  click: function ($event) {
                                    _vm.showFilterPanel = !_vm.showFilterPanel
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.trans("general.cancel")))]
                            )
                          : _vm._e(),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.hasPermission("create-user")
                ? _c("transition", { attrs: { name: "fade" } }, [
                    _vm.showCreatePanel
                      ? _c("div", { staticClass: "card border-bottom" }, [
                          _c("div", { staticClass: "card-body p-4" }, [
                            _c(
                              "form",
                              {
                                attrs: { autocomplete: "off" },
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return _vm.submit.apply(null, arguments)
                                  },
                                  keydown: function ($event) {
                                    return _vm.userForm.errors.clear(
                                      $event.target.name
                                    )
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-sm-12" },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-12 col-sm-3" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans(
                                                          "user.first_name"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.userForm.first_name,
                                                      expression:
                                                        "userForm.first_name",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    value: "",
                                                    name: "first_name",
                                                    placeholder:
                                                      _vm.trans(
                                                        "user.first_name"
                                                      ),
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.userForm.first_name,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.userForm,
                                                        "first_name",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("show-error", {
                                                  attrs: {
                                                    "form-name": _vm.userForm,
                                                    "prop-name": "first_name",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-12 col-sm-3" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans(
                                                          "user.last_name"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.userForm.last_name,
                                                      expression:
                                                        "userForm.last_name",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    value: "",
                                                    name: "last_name",
                                                    placeholder:
                                                      _vm.trans(
                                                        "user.last_name"
                                                      ),
                                                    autocomplete: "off",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.userForm.last_name,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.userForm,
                                                        "last_name",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("show-error", {
                                                  attrs: {
                                                    "form-name": _vm.userForm,
                                                    "prop-name": "last_name",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-12 col-sm-3" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans(
                                                          "user.password"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.userForm.password,
                                                      expression:
                                                        "userForm.password",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "password",
                                                    value: "",
                                                    name: "password",
                                                    placeholder:
                                                      _vm.trans(
                                                        "user.password"
                                                      ),
                                                    autocomplete:
                                                      "new-password",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.userForm.password,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.userForm,
                                                        "password",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("show-error", {
                                                  attrs: {
                                                    "form-name": _vm.userForm,
                                                    "prop-name": "password",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-12 col-sm-3" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans(
                                                          "user.password_confirmation"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.userForm
                                                          .password_confirmation,
                                                      expression:
                                                        "userForm.password_confirmation",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "password",
                                                    value: "",
                                                    name: "password_confirmation",
                                                    placeholder: _vm.trans(
                                                      "user.password_confirmation"
                                                    ),
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.userForm
                                                        .password_confirmation,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.userForm,
                                                        "password_confirmation",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("show-error", {
                                                  attrs: {
                                                    "form-name": _vm.userForm,
                                                    "prop-name":
                                                      "password_confirmation",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-12 col-sm-3" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans("user.email")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.userForm.email,
                                                      expression:
                                                        "userForm.email",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    value: "",
                                                    name: "email",
                                                    placeholder:
                                                      _vm.trans("user.email"),
                                                    autocomplete: "off",
                                                  },
                                                  domProps: {
                                                    value: _vm.userForm.email,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.userForm,
                                                        "email",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("show-error", {
                                                  attrs: {
                                                    "form-name": _vm.userForm,
                                                    "prop-name": "email",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-info waves-effect waves-light pull-right",
                                    attrs: { type: "submit" },
                                  },
                                  [_vm._v(_vm._s(_vm.trans("general.add")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-danger waves-effect waves-light pull-right m-r-10",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.showCreatePanel =
                                          !_vm.showCreatePanel
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.trans("general.cancel")))]
                                ),
                              ]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.users.total
                ? _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _vm.hasPermission("list-user") && _vm.users.total
                          ? _c("div", { staticClass: "table-responsive" }, [
                              _c(
                                "table",
                                { staticClass: "table table-hover" },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v("Outstanding"),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v("Rep."),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(
                                          _vm._s(_vm.trans("user.first_name"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(
                                          _vm._s(_vm.trans("user.last_name"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(_vm._s(_vm.trans("user.email"))),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v("Premium"),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v("Last Login"),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v("Register Status"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "table-option",
                                          attrs: { scope: "col" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.trans("general.action"))
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.users.data, function (user) {
                                      return user.profile
                                        ? _c("tr", [
                                            _c(
                                              "td",
                                              {
                                                class:
                                                  user.profile.status_id == 2
                                                    ? "pta-status-won"
                                                    : user.profile.status_id ==
                                                      3
                                                    ? "pta-status-lost"
                                                    : "pta-status-open",
                                              },
                                              [
                                                user.profile.email_status ==
                                                  4 &&
                                                user.profile.is_intro_call == 0
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pta-os-label",
                                                      },
                                                      [_vm._v("Intro Call")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                user.profile
                                                  .email_sales_status == 8 &&
                                                user.profile.is_final_call == 0
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pta-os-label",
                                                      },
                                                      [_vm._v("Final Call")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                user.profile
                                                  .is_premium_investors == 1 &&
                                                user.profile.is_confirmed == 0
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pta-os-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "LP list approval"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  user.profile
                                                    .account_manager_id == 1
                                                    ? "Lawin"
                                                    : user.profile
                                                        .account_manager_id == 2
                                                    ? "Namo"
                                                    : user.profile
                                                        .account_manager_id == 3
                                                    ? "Sajith"
                                                    : user.profile
                                                        .account_manager_id == 4
                                                    ? "Tad"
                                                    : "-"
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            user.profile
                                              ? _c("td", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      user.profile.first_name
                                                    ),
                                                  },
                                                })
                                              : _c("td", [_vm._v("-")]),
                                            _vm._v(" "),
                                            user.profile
                                              ? _c("td", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      user.profile.last_name
                                                    ),
                                                  },
                                                })
                                              : _c("td", [_vm._v("-")]),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(user.email),
                                              },
                                            }),
                                            _vm._v(" "),
                                            user.profile
                                              ? _c("td", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      user.profile.is_premium
                                                        ? "Yes"
                                                        : "No"
                                                    ),
                                                  },
                                                })
                                              : _c("td", [_vm._v("-")]),
                                            _vm._v(" "),
                                            user.user_last_login
                                              ? _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("momentTime")(
                                                        user.user_last_login
                                                          .created_at
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _c("td", [_vm._v("-")]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              _vm._l(
                                                _vm.getUserStatus(user),
                                                function (status) {
                                                  return _c(
                                                    "span",
                                                    {
                                                      class: [
                                                        "label",
                                                        "label-" + status.color,
                                                        "m-r-5",
                                                      ],
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(status.label)
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _vm._v(" "),
                                            user.profile
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass: "table-option",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "btn-group",
                                                      },
                                                      [
                                                        user.investors.length &&
                                                        user.profile
                                                          .is_confirmed == 1
                                                          ? _c(
                                                              "button",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "tooltip",
                                                                    rawName:
                                                                      "v-tooltip",
                                                                    value:
                                                                      "Message preview",
                                                                    expression:
                                                                      "'Message preview'",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "btn btn-info btn-sm",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.showMessage(
                                                                        user.id
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas fa-envelope",
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        user.investors.length &&
                                                        user.profile
                                                          .is_confirmed == 1
                                                          ? _c(
                                                              "router-link",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "tooltip",
                                                                    rawName:
                                                                      "v-tooltip",
                                                                    value:
                                                                      "Campaign",
                                                                    expression:
                                                                      "'Campaign'",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "btn btn-info btn-sm",
                                                                attrs: {
                                                                  to: `/account/users/general-partners/${user.id}/campaign`,
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas fa-bolt",
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "router-link",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip",
                                                                value:
                                                                  _vm.trans(
                                                                    "user.view_user"
                                                                  ),
                                                                expression:
                                                                  "trans('user.view_user')",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "btn btn-edit btn-sm",
                                                            attrs: {
                                                              to: `/account/users/general-partners/${user.id}`,
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-arrow-circle-right",
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.hasPermission(
                                                          "delete-user"
                                                        )
                                                          ? _c(
                                                              "button",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "confirm",
                                                                    rawName:
                                                                      "v-confirm",
                                                                    value: {
                                                                      ok: _vm.confirmDelete(
                                                                        user
                                                                      ),
                                                                      message:
                                                                        "Do you really want to delete the user?",
                                                                      okText:
                                                                        "Delete",
                                                                      cancelText:
                                                                        "Cancel",
                                                                    },
                                                                    expression:
                                                                      "{ok: confirmDelete(user), message: 'Do you really want to delete the user?', okText: 'Delete', cancelText: 'Cancel'}",
                                                                  },
                                                                  {
                                                                    name: "tooltip",
                                                                    rawName:
                                                                      "v-tooltip",
                                                                    value:
                                                                      _vm.trans(
                                                                        "user.delete_user"
                                                                      ),
                                                                    expression:
                                                                      "trans('user.delete_user')",
                                                                  },
                                                                ],
                                                                key: user.id,
                                                                staticClass:
                                                                  "btn btn-danger btn-sm",
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas fa-trash",
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              : _c("td"),
                                          ])
                                        : _vm._e()
                                    }),
                                    0
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("pagination-record", {
                          attrs: {
                            "page-length": _vm.filterUserForm.page_length,
                            records: _vm.users,
                          },
                          on: {
                            "update:pageLength": function ($event) {
                              return _vm.$set(
                                _vm.filterUserForm,
                                "page_length",
                                $event
                              )
                            },
                            "update:page-length": function ($event) {
                              return _vm.$set(
                                _vm.filterUserForm,
                                "page_length",
                                $event
                              )
                            },
                            updateRecords: _vm.getUsers,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modal fade", attrs: { id: "modalMessage" } }, [
      _c(
        "div",
        { staticClass: "modal-dialog", staticStyle: { "max-width": "920px" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c(
              "div",
              {
                staticClass: "modal-header",
                staticStyle: { display: "block" },
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "h4",
                  { staticClass: "modal-title", attrs: { id: "modalTitle" } },
                  [
                    _vm._v(
                      "Message preview (" + _vm._s(_vm.cur_message_name) + ")"
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modal-body",
                staticStyle: { "font-size": "18px", "line-height": "24px" },
                attrs: { id: "modalBody" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "carousel slide",
                    attrs: {
                      id: "carouselExampleIndicators",
                      "data-ride": "carousel",
                    },
                  },
                  [
                    _c("ol", { staticClass: "carousel-indicators" }, [
                      _c("li", {
                        staticClass: "active",
                        attrs: {
                          "data-target": "#carouselExampleIndicators",
                          "data-slide-to": "0",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSlide(0)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("li", {
                        attrs: {
                          "data-target": "#carouselExampleIndicators",
                          "data-slide-to": "1",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSlide(1)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("li", {
                        attrs: {
                          "data-target": "#carouselExampleIndicators",
                          "data-slide-to": "2",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSlide(2)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("li", {
                        attrs: {
                          "data-target": "#carouselExampleIndicators",
                          "data-slide-to": "3",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSlide(3)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("li", {
                        attrs: {
                          "data-target": "#carouselExampleIndicators",
                          "data-slide-to": "4",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSlide(4)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _vm.messages[0]
                      ? _c("div", { staticClass: "carousel-inner" }, [
                          _c("div", {
                            staticClass: "carousel-item active",
                            domProps: {
                              innerHTML: _vm._s(_vm.messages[0].message),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "carousel-item",
                            domProps: {
                              innerHTML: _vm._s(_vm.messages[1].message),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "carousel-item",
                            domProps: {
                              innerHTML: _vm._s(_vm.messages[2].message),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "carousel-item",
                            domProps: {
                              innerHTML: _vm._s(_vm.messages[3].message),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "carousel-item",
                            domProps: {
                              innerHTML: _vm._s(_vm.messages[4].message),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "carousel-control-prev",
                        attrs: {
                          href: "#carouselExampleIndicators",
                          role: "button",
                          "data-slide": "prev",
                        },
                        on: { click: _vm.onSlidePrev },
                      },
                      [
                        _c("span", {
                          staticClass: "carousel-control-prev-icon",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Previous"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "carousel-control-next",
                        attrs: {
                          href: "#carouselExampleIndicators",
                          role: "button",
                          "data-slide": "next",
                        },
                        on: { click: _vm.onSlideNext },
                      },
                      [
                        _c("span", {
                          staticClass: "carousel-control-next-icon",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Next"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: { type: "button", "data-dismiss": "modal" },
      },
      [
        _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")]),
        _vm._v(" "),
        _c("span", { staticClass: "sr-only" }, [_vm._v("close")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }